import type { IMBEStore } from '@/types';
import { Button, Flex, Text } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IStoreInfoWindowProps {
  onSelect?: (store: IMBEStore) => void;
  store: IMBEStore;
}

export const StoreInfoWindow: React.FC<IStoreInfoWindowProps> = ({
  onSelect,
  store,
}): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Flex direction="column">
      <Text pb={4}>
        {store.name} <br />
        <Text as="span" fontSize="small">
          {store.streetAddress} , {store.city}
        </Text>
      </Text>
      <Text as="span" fontSize="small" pb={8}>
        {t('STORE.PHONE_NUMBER')} {store.phoneNumber} <br />
        {t('STORE.MAIL')} {store.email}
      </Text>
      {onSelect && (
        <Button
          alignSelf="flex-end"
          color="brand.red.light"
          paddingInline={0}
          py={0}
          variant="link"
          onClick={(): void => onSelect(store)}
        >
          {t('ACTIONS.SELECT')}
        </Button>
      )}
    </Flex>
  );
};
